import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { usePwaInstall } from "@/contexts/pwaInstall/PwaInstallContext";

// ------------------------------- COMPONENT -------------------------------
export default function PwaInstallButton() {
	const { podeInstalar, instalando, aoInstalar } = usePwaInstall();
	if (!podeInstalar) return null;

	return (
		<Tooltip title="Instalar aplicativo" placement="bottom">
			<span className="inline-flex">
				<IconButton
					size="small"
					aria-label="Instalar aplicativo"
					aria-busy={instalando}
					disabled={instalando}
					onClick={() => {
						void aoInstalar();
					}}
				>
					<FuseSvgIcon>lucide:download</FuseSvgIcon>
				</IconButton>
			</span>
		</Tooltip>
	);
}
